import React, { useEffect, useState } from "react";
import { socket } from "../utils/customFn";

function Socket() {
  const [isConnected, setIsConnected] = useState(socket.connected);
  const [orders, setOrders] = useState([]);
  const [messages, setMessages] = useState([]);
  const [currentMessage, setCurrentMessage] = useState("");
  const [currentOrderId, setCurrentOrderId] = useState(107);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);

    console.log("files", files);

    const base64Files = await Promise.all(
      files.map(async (file) => {
        const base64 = await convertToBase64(file);
        const rawBase64 = base64.split(",")[1];
        return rawBase64;
      })
    );

    console.log("base64Files", base64Files);
    setSelectedFiles(base64Files);
  };

  const convertToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const sendMessage = () => {
    socket.emit("contact_support", {
      senderId: 16,
      receiverId: 1,
      message: currentMessage,
      senderType: "Client",
    });

    if (currentOrderId) {
      socket.emit("send_message", {
        orderId: currentOrderId,
        message: currentMessage,
        attachments: selectedFiles,
        attachments_type: "image",
      });
      setCurrentMessage("");
      setSelectedFiles([]);
    }
  };

  useEffect(() => {
    socket.on("connect", () => {
      console.log("Connected to Socket.io server");
      setIsConnected(true);
      socket.emit("online_driver_id", 13);
      socket.emit("set_language", 2);
    });

    socket.on("chat:user_joined", (data) => {
      console.log("chat:user_joined", data);
    });

    socket.on(`cancel_order_${currentOrderId}`, (data) => {
      alert(data);
      console.log("currentOrderId", data);
    });

    socket.on("chat_support_msg", (message) => {
      console.log("New message chat_support_msg:", message);
      setMessages((prev) => [...prev, message]);
    });

    // Chat-related listeners
    socket.on("receive_message", (message) => {
      console.log("New message received:", message);
      setMessages((prev) => [...prev, message]);
    });

    socket.on("chat_error", (error) => {
      console.error("Chat error:", error);
    });

    socket.on("offer_accepted", (orderid) => {
      console.log("offer_accepted:", orderid);
    });

    socket.on("offer_declined_by_client", (orderid) => {
      console.log("offer_declined_by_client:", orderid);
    });

    socket.on("chat_joined", (message) => {
      console.log(message);
    });

    socket.on("new_order", (message) => {
      console.log(message);
    });

    socket.on("driver:client_info_receive", (message) => {
      console.log("driver:client_info_receive", message);
    });

    socket.on("receive_message", (data) => {
      setMessages((prev) => [
        ...prev,
        {
          message: data.message,
          sender_id: data.senderId,
          fileUrl: data.fileUrl,
          fileName: data.fileName,
          fileType: data.fileType,
          timestamp: data.timestamp,
          seen: false,
        },
      ]);
    });

    socket.on("driver:order_delivered", (data) => {
      console.log("driver:order_delivered", data);
    });

    return () => {
      // Cleanup chat listeners
      socket.off("receive_message");
      socket.off("chat_error");
      socket.off("chat_joined");
      socket.off("driver_initiate_pickup");
      // ... other cleanup ...
    };
  }, []);

  const joinChat = () => {
    if (currentOrderId) {
      socket.emit("join_order_chat", currentOrderId);
    }
  };

  socket.on("pickup_error", (data) => {
    console.log("pickup_error", data);
  });

  const leaveChat = () => {
    if (currentOrderId) {
      socket.emit("leave_order_chat", currentOrderId);
    }
  };

  // chat confirm status ==================================================
  // Driver initiates pickup
  const handlePickupInitiation = () => {
    socket.emit("driver:pickup_initiate", currentOrderId);
  };

  const handleOrderReceivedConfirmedByDriver = () => {
    console.log("test");
    socket.emit("driver:confirmed_order_receive", currentOrderId);
  };

  // const handleOrderDeliveredByDriver = () => {
  //   socket.emit('driver:delivery_complete', currentOrderId);
  // };

  const handleOrderDeliveredByDriver = () => {
    socket.emit("driver:delivery", currentOrderId);
  };

  return (
    <div>
      <h1>Socket.io Connection Status</h1>

      <p>
        {isConnected ? (
          <span style={{ color: "green" }}>Connected</span>
        ) : (
          <span style={{ color: "red" }}>Disconnected</span>
        )}
      </p>

      <button
        type="button"
        className="pickup-button"
        onClick={handlePickupInitiation}
      >
        Initiate Pickup
      </button>

      <button
        type="button"
        className="pickup-button"
        onClick={handleOrderReceivedConfirmedByDriver}
      >
        handleOrderReceivedConfirmedByDriver
      </button>

      <button
        type="button"
        className="pickup-button"
        onClick={handleOrderDeliveredByDriver}
      >
        handleOrderDeliveredByDriver
      </button>

      <div style={{ margin: "20px 0" }}>
        <h2>Order Chat Test</h2>
        <input
          type="number"
          value={currentOrderId}
          onChange={(e) => setCurrentOrderId(e.target.value)}
          placeholder="Enter Order ID"
        />
        <button onClick={joinChat}>Join Chat</button>
        <button onClick={leaveChat}>Leave Chat</button>

        <div style={{ marginTop: "10px" }}>
          <input
            type="text"
            value={currentMessage}
            onChange={(e) => setCurrentMessage(e.target.value)}
            placeholder="Type a message"
            onKeyPress={(e) => e.key === "Enter" && sendMessage()}
          />
          <input
            type="file"
            multiple
            onChange={handleFileChange}
            style={{ marginTop: "10px", display: "block" }}
          />
          <button onClick={sendMessage}>Send Message</button>
        </div>

        {selectedFiles.length > 0 && (
          <div>
            <strong>Files to send:</strong>
            <ul>
              {selectedFiles.map((file, idx) => (
                <li key={idx}>{file.name}</li>
              ))}
            </ul>
          </div>
        )}

        <div style={{ marginTop: "20px" }}>
          <h3>Chat Messages</h3>
          <ul>
            {messages.map((msg, index) => (
              <li key={index}>
                <strong>{msg.sender_type}:</strong> {msg.message}
                <br />
                <small>{new Date(msg.timestamp).toLocaleTimeString()}</small>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Existing orders display */}
      <h2>Orders</h2>
      <ul>
        {orders.map((order, index) => (
          <li key={index}>
            Order ID: {order.id}, Distance: {order.distance} km
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Socket;
